export const CREATE_ATTENDANCE_CHECK_IN_OUT = "CREATE_ATTENDANCE_CHECK_IN_OUT";
export const FETCH_ATTENDANCE_CHECK_IN_OUT = "FETCH_ATTENDANCE_CHECK_IN_OUT";
export const FETCH_ATTENDANCE_CHECK_IN_OUT_BY_ID =
  "FETCH_ATTENDANCE_CHECK_IN_OUT_BY_ID";
export const EDIT_ATTENDANCE_CHECK_IN_OUT = "EDIT_ATTENDANCE_CHECK_IN_OUT";
export const DELETE_ATTENDANCE_CHECK_IN_OUT = "DELETE_ATTENDANCE_CHECK_IN_OUT";
